import React, { FC } from 'react'
import Modal from './Modal'
import { ModalAction, ModalImg, ModalMessege, ModalWrapper } from './StyleDeleteModal'
import Button from '../UI/Button/Button'
import warning from "../../assets/images/warningSign.png";


enum ButtonSize {
    sm = "small",
    md = "medium",
    lg = "large",
  }
  enum ButtonVariant {
    primaryFilled = "primary-filled",
    secondary = "secondary",
    primaryLink = "primaryLink",
    danger = "danger",
    dangerOutline="dangerOutline"
  }

interface ModalProp{
    openModal:boolean,
    setOpenModal:any,
    confirm:any,
    title:string,
    content:string
}

const ActionModal:FC<ModalProp> = ({openModal,setOpenModal,confirm,title,content}) => {
  return (
    <>
    <Modal
          isOpen={openModal}
          name={"Create delete Modal"}
          title={title}
          toggleModal={() => setOpenModal(false)}
        >
          <ModalWrapper>
            <ModalImg>
              <img
                src={warning}
                alt="warning"
                width={"150px"}
                height={"150px"}
              />
            </ModalImg>
            <ModalMessege>
              Are you sure, You want to {title} this {content}?
            </ModalMessege>
            <ModalAction>
              <Button
                title={"No"}
                btnSize={ButtonSize.md}
                btnVariant={ButtonVariant.dangerOutline}
                clicked={() => setOpenModal(false)}
              />
              <Button
                title={"Yes"}
                btnSize={ButtonSize.md}
                btnVariant={ButtonVariant.danger}
                clicked={confirm}
              />
            </ModalAction>
          </ModalWrapper>
        </Modal>
    </>
  )
}

export default ActionModal